
import { Options, Vue } from 'vue-class-component'
@Options({
  data () {
    return {
      chairs: [
        { name: 'Dream+ 100BL', file: 'dream+100BL.glb', id: 'dream+100BL' },
        { name: 'Dream+ 100BL,BR', file: 'dream+100BLBR.glb', id: 'dream+100BLBR' },
        { name: 'Dream+ 100BL,BR,RM60', file: 'dream+100BLBRRM60.glb', id: 'dream+100BLBRRM60' },
        { name: 'Dream+ 100BL,RM60', file: 'dream+100BLRM60.glb', id: 'dream+100BLRM60' },
        { name: 'Dream+ 100WH', file: 'dream+100WH.glb', id: 'dream+100WH' },
        { name: 'Dream+ 100WH,BR', file: 'dream+100WHBR.glb', id: 'dream+100WHBR' },
        { name: 'Dream+ 101BL-Z', file: 'dream+101BLZ.glb', id: 'dream+101BLZ' },
        { name: 'Dream+ 101BL-Z,BR', file: 'dream+101BLZBR.glb', id: 'dream+101BLZBR' },
        { name: 'Dream+ 101WH-Z', file: 'dream+101WHZ.glb', id: 'dream+101WHZ' },
        { name: 'Dream+ 101WH-Z,BR', file: 'dream+101WHZBR.glb', id: 'dream+101WHZBR' },
        { name: 'Dream+ 103BL', file: 'dream+103BL.glb', id: 'dream+103BL' },
        { name: 'Dream+ 103BL,BR', file: 'dream+103BLBR.glb', id: 'dream+103BLBR' },
        { name: 'Dream+ 103WH', file: 'dream+103WH.glb', id: 'dream+103WH' },
        { name: 'Dream+ 103WH,BR', file: 'dream+103WHBR.glb', id: 'dream+103WHBR' },
        { name: 'Dream+ 104BL-Z', file: 'dream+104BLZ.glb', id: 'dream+104BLZ' },
        { name: 'Dream+ 104BL-Z,BR', file: 'dream+104BLZBR.glb', id: 'dream+104BLZBR' },
        { name: 'Dream+ 104WH-Z', file: 'dream+104WHZ.glb', id: 'dream+104WHZ' },
        { name: 'Dream+ 104WH-Z,BR', file: 'dream+104WHZBR.glb', id: 'dream+104WHZBR' },
        { name: 'Leaf 503-SY', file: 'leaf503-SY.glb', id: 'leaf503-SY' }
      ]
    }
  }
})

export default class ChairPicker extends Vue {}
